/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * This enum is used as the client-facing representation of a "product" that can be purchased
 * in CHAI. This is what the system can expect to receive when constructing a Stripe checkout and
 * is mappable to a ChaiStripePriceLookupKey via the ChaiProduct class. This provides a layer of
 * indirection between the user-facing product selection and the ultimate Stripe product
 * resolution in the backend so we do not tightly couple the presentation to the purchase.
 */
export type ProductOption = (typeof ProductOption)[keyof typeof ProductOption];

export const ProductOption = {
  live_chat: "live_chat",
  live_video: "live_video",
  async_rx: "async_rx",
  async_dx: "async_dx",
  rx_renewal: "rx_renewal",
  all_you_can_eat_subscription: "all_you_can_eat_subscription",
} as const;
